import styled from "styled-components";

export const ModalWindowContainer = styled.div`
  background-color: rgba(98, 104, 107, 0.7);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
